import axios from 'axios';
import config from '../config/config';

const API_BASE = `${config.API_BASE}/users`;

export const listarUsuarios = () => axios.get(API_BASE);
export const obterUsuario = (id) => axios.get(`${API_BASE}/${id}`);
export const usuarioExistente = (identificador) => axios.get(`${API_BASE}/identificador/${identificador}`);
export const cadastrarUsuario = (dados) => axios.post(API_BASE, dados);
export const atualizarUsuario = (id, dados) => axios.put(`${API_BASE}/${id}`, dados);
export const removerUsuario = (id) => axios.delete(`${API_BASE}/${id}`);
export const loginUsuario = (identificador, senha) => axios.post(API_BASE, { identificador, senha });
